import React from "react";
import { Store, Compass, Package, Sparkles } from "lucide-react";

export const ProblemSolution = () => {
  return (
    <section
      data-testid="problem-solution-section"
      className="relative py-16 md:py-24 lg:py-28 bg-slate-50/60 border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs tracking-[0.2em] text-[#65a30d] font-semibold uppercase">
              Why Execora
            </div>

            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.1]">
              Your neighbourhood already has everything you need.
              <br />
              <span className="text-[#65a30d]">It’s just not online.</span>
            </h2>

            <p className="mt-5 text-slate-600 text-base sm:text-lg leading-relaxed">
              The nearby florist. The local photocopy shop. The person who irons your clothes.
              Most of these services aren’t online, which makes them hard to access when you need them.
            </p>

            <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed">
              Execora connects you to trusted shops around you and handles the pickup and delivery.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              {
                icon: Store,
                title: "Discovery",
                body: "Tell us what you need — we find the right shop nearby.",
              },
              {
                icon: Compass,
                title: "Ordering",
                body: "Just message us on WhatsApp. No apps, no complicated steps.",
              },
              {
                icon: Package,
                title: "Fulfilment",
                body: "We get it from a local shop and deliver it to your doorstep.",
              },
              {
                icon: Sparkles,
                title: "Experience",
                body: "Simple, reliable, and local — like asking someone who knows the area.",
              },
            ].map((b, i) => (
              <div
                key={b.title}
                data-testid={`problem-solution-card-${i}`}
                className="group relative bg-white rounded-2xl p-6 border border-slate-100 hover:border-slate-200 shadow-sm hover:shadow-md transition-all duration-300"
              >
                <div className="h-10 w-10 rounded-xl bg-[#84cc15]/12 flex items-center justify-center mb-4">
                  <b.icon className="h-5 w-5 text-[#65a30d]" strokeWidth={2} />
                </div>

                <div className="text-lg font-semibold text-slate-900 tracking-tight">
                  {b.title}
                </div>

                <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">
                  {b.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
